/* tslint:disable */
/* New Journey Flow */
import * as React from 'react';
import {Field, FieldArray, formValueSelector, InjectedFormProps, reduxForm, submit} from 'redux-form';
import {difference, find, flow, forEach, get, isEmpty, map, size} from 'lodash';
import {IBrandingActions, IBrandingState, II18nMessages} from '../../../../services/branding/models';
import {Button, Col, ControlLabel, Form, FormGroup, Modal, Row} from 'react-bootstrap';
import FieldFormControl from '../../../../components/FieldFormControl';
import {connect} from 'react-redux';
import AlternativeDatePicker from '../../../../components/AlternativeDatePicker/index';
import {
    IChannel,
    IDestination,
    IIndustry,
    IOccupation,
    IPolicyApplication,
    IProduct,
    ITraveller,
    TripType,
} from '../../../../data/api/models';
import {
    annualLimit,
    isAfter,
    isBefore,
    isFutureDate,
    isNotFalse,
    isRequired,
    isValidDate,
    singleLimit,
    singleMaxTripDuration,
    mustConfirm
} from '../../../../util/validators';
import * as moment from 'moment';
import {isAnnual, showDestinationDuration} from '../../../../data/api/api';
import {actions as quoteActions, getInitValues} from '../../../../services/quote/reducer';
import {actions as brandingActions} from '../../../../services/branding/reducer';
import {IAuthState} from '../../../../services/auth/models';
import {bindActionCreators} from 'redux';
import {IQuoteActions} from '../../../../services/quote/models';
import Travellers from './components/Travellers';
import FaChevronRight from 'react-icons/fa/chevron-right';
import MarketingOptions from '../../components/MarketingOptions';
import {IStore} from '../../../../redux/IStore';
import GroupType from '../TripDetails/components/GroupType/GroupType';
import GroupTypeSelected from '../TripDetails/components/GroupType/GroupTypeSelected';
import MaxTripDuration from '../TripDetails/components/MaxTripDuration/MaxTripDuration';
import SelectControl from '../../../../components/SelectControl';
import ReactMarkdown = require('react-markdown');
import FaCheck from 'react-icons/fa/check';
import Destination from './components/Destination';
import MembershipDetails from './components/MembershipDetails';
import {scrollToFirstError} from '../../../../util/scrollToFirstError';
import FCDOText from './components/FCDOText';
import VoucherCode from '../../components/VoucherCode';
import {setMaxTripDuration} from './tripJourney.helpers';

interface ITripDetailsJourneyBFormProps extends InjectedFormProps {
    destinations: IDestination[];
    occupations: IOccupation[];
    industries: IIndustry[];
    auth: IAuthState;
    i18n: II18nMessages;
    travellers: ITraveller[];
    groupType: string;
    cruiseCover: boolean;
    tripType: TripType;
    startDate: string;
    region: string;
    maxTripDuration: string;
    schemeId: string;
    endDate: string;
    dispatch: any;
    product: IProduct;
    destinationsValue: string[];
    occupationValue: string[];
    industryValue: string[];
    channel: IChannel;
    quote: IPolicyApplication;
    branding: IBrandingState;

    renderDefinition(name: string): any;

    actions: {
        quote: IQuoteActions;
        branding: IBrandingActions;
        submit(name: string);
    };

    campaignCode?: string;
    camcMembership: string | null;
    addressSelected: boolean | null;
    maydayBreakdown: string | null;
}

interface ISourceOption {
    value: string;
    label: string;
}

interface ITripDetailsStates {
    showBlockerModal: boolean;
    modalMessage: string;
    region: string;
    activities: string[];
    activitiesValid: boolean;
    backToIndividual: boolean;
    sources: ISourceOption[];
}

class TripDetailsJourneyBForm extends React.Component<ITripDetailsJourneyBFormProps, ITripDetailsStates> {
    public state = {
        showBlockerModal: false,
        modalMessage: '',
        region: '',
        activities: [],
        activitiesValid: true,
        backToIndividual: false,
        sources: [],
    };

    public componentWillMount() {
        const {product, change, initialValues, dispatch, channel, auth, campaignCode, branding} = this.props;
        const data = getInitValues(product, null, null);

        forEach(data, (value, key) => {
            if (initialValues[key] === null) {
                change(key, value);
            }
        });

        const dateFromApi = (date) => {
            if (!date) {
                return '';
            }

            const parsedDate = moment(date).format('DD/MM/YYYY');

            return parsedDate !== 'Invalid Date' ? parsedDate : '';
        };

        dispatch(change('salesChannel', channel.key));
        dispatch(change('quotationTypes', 'Direct'));

        if (campaignCode) {
            dispatch(change('campaignCode', campaignCode));
        }

        if (auth.isAuthenticated) {
            dispatch(change('travellers[0].title', auth.customer.title));
            dispatch(change('travellers[0].dob', dateFromApi(auth.customer.dob)));
            dispatch(change('travellers[0].firstName', auth.customer.firstName));
            dispatch(change('travellers[0].lastName', auth.customer.lastName));
            dispatch(change('travellers[0].email', auth.customer.email));
            dispatch(change('travellers[0].phone', auth.customer.phone1));
            dispatch(change('travellers[0].address.postcode', auth.customer.address.postcode));
            dispatch(change('travellers[0].address.line1', auth.customer.address.line1));
            dispatch(change('travellers[0].address.line2', auth.customer.address.line2));
            dispatch(change('travellers[0].address.town', auth.customer.address.town));
            dispatch(change('travellers[0].address.country', auth.customer.address.country));
        }
        if (branding && branding.trackingLink) {
            const mappedSources = [{
                value: branding.trackingLink.id,
                label: branding.trackingLink.name,
            }];
            this.setState({sources: mappedSources});
        } else {
            this.props.actions.branding.getSources(product.id)
                .then((sources) => {
                    const mappedSources = sources
                        .filter(src => src.name === 'CSIS Travel Cover')
                        .map(src => ({
                            value: src.id,
                            label: src.name
                        }));

                    this.setState({sources: mappedSources});
                })
                .catch((err) => {
                    console.error('Failed to load sources', err);
                });
        }

    }

    public componentDidUpdate() {
        const {tripType, dispatch, change, channel, travellers} = this.props;
        const { region } = this.state;
        setMaxTripDuration(tripType, channel, travellers, dispatch, change, region)
    }

    private getAge = (dob) => {

        if (isEmpty(dob)) {
            return null;
        }

        const convertedDate = dob.split(/\//).reverse().join('/');
        return moment().diff(convertedDate, 'years');
    };

    public componentWillReceiveProps(nextProps) {
        const {tripType, dispatch, change, actions, schemeId} = this.props;

        if (schemeId && tripType !== nextProps.tripType) {
            dispatch(change('schemeId', ''));
            actions.quote.calculate(null, true);
        }
    }

    public renderAboutUs = () => {
        const {channel} = this.props;

        const TERMS_OF_BUSINESS = 'Terms of Business';
        const aiosDocument = find(channel.productDocuments, (document) => {
            return document.shortName === TERMS_OF_BUSINESS;
        });
        const aboutUsUrl = aiosDocument ? aiosDocument.filePath : '';

        return (
            <div className="margin-top margin-bottom">
                For more information about our service to you and how we will use your information,
                please read our <a href={aboutUsUrl} target="_blank"><strong>Terms of Business</strong> </a>
                and our <a href={get(channel, channel.key === 'npo-b2c' ? 'urls.privacy' : 'urls.privacyCookies', '')} target="_blank">
                <strong>Privacy Policy</strong></a>.
            </div>
        );
    };

    private checkForErrorBeforeSubmit = () => {
        const {
            tripType,
            startDate,
            dispatch,
            change,
            endDate,
            travellers,
            actions,
            product,
            maxTripDuration,
            channel
        } = this.props;
        const start = moment(startDate, 'DD/MM/YYYY');
        const end = moment(endDate, 'DD/MM/YYYY');
        const tripDuration = tripType === 'single' ? end.diff(start, 'days') : maxTripDuration;

        if (tripType === 'single') {
            dispatch(change('maxTripDuration', tripDuration));
        }
        const validationRules = {
            CSIS: {
                single: [
                    {maxTrip: 90, maxAge: 79},
                ],
                annual: [],
            },
            TPL: {
                single: [
                    {maxTrip: 90, maxAge: 79},
                ],
                annual: [],
            },
            CAMC: {
                single: [
                    {maxTrip: 90, maxAge: 79},
                ],
                annual: [],
            },
        };

        const validationMessages = {};

        let message;
        const rules = validationRules[product.productCode] && validationRules[product.productCode][tripType] || [];
        const valid = travellers.reduce((carry, traveller) => {
            const travellerAge = this.getAge(traveller.dob);
            return carry && rules.reduce((carry, rule) => {
                if (rule.maxAge) {
                    if (travellerAge > rule.maxAge) {
                        carry = rule.maxTrip ? carry && tripDuration <= rule.maxTrip : carry && travellerAge <= rule.maxAge;
                    }
                    return carry;
                }
            }, true);
        }, true);
        message = validationMessages[product.productCode] || 'Sorry, ' + channel.name +
            ' is unable to provide a quote online due to your planned trip duration.';

        if (!valid) {
            this.setState({
                showBlockerModal: true,
                modalMessage: message,
            });
        } else {
            actions.submit('quote');
        }
    };

    private closeBlockerModal = () => {
        this.setState({
            showBlockerModal: false,
        });
    };

    private renderBlockerModal = () => {
        const {channel} = this.props;
        const {modalMessage} = this.state;

        return (
            <Modal show={this.state.showBlockerModal} onHide={this.closeBlockerModal}>
                <Modal.Header closeButton={true}>
                    <Modal.Title>Attention required</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <ul>
                        <li>
                            <p>
                                {modalMessage}
                            </p>
                            <p>
                                Please call our specialist UK-based customer services team
                                on <strong>{channel.phone}</strong> to see if we can provide you with a quote.
                            </p>
                            <p>
                                We are open {channel.openingHours} closed Bank Holidays.
                            </p>
                        </li>
                    </ul>
                </Modal.Body>
                <Modal.Footer>
                    <Button
                        bsStyle="primary"
                        onClick={this.closeBlockerModal}
                    >
                        CLOSE
                    </Button>
                </Modal.Footer>
            </Modal>
        );
    };

  private handleRegion = (newValue: any, _prev?: any, _name?: string) => {
    const raw =
        newValue && typeof newValue === 'object' && 'value' in newValue
            ? (newValue as any).value
            : newValue;

    // force primitive string
    const value =
        typeof raw === 'string'
            ? raw
            : raw instanceof String
                ? raw.valueOf()
                : String(raw);

    this.props.change('region', value);
    this.setState({ region: value });
  };

    private onSelectGroupType = (value: any) => {
        if ('individual' === value.target.value) {
            this.setState({
                backToIndividual: true,
            });
        }
    };

    handleEndDate = (newValue: string) => {
        const {change, dispatch} = this.props;

        const start = moment(newValue, 'DD/MM/YYYY', true);

        if (!start.isValid()) {
            return;
        }

        const end = start
            .clone()
            .add(1, 'year')
            .subtract(1, 'day')
            .hour(23)
            .minute(59)
            .second(59);

        dispatch(change('endDate', end.format('DD/MM/YYYY')));
    };

    public render() {
        const {
            i18n,
            submitting,
            tripType,
            handleSubmit,
            valid,
            startDate,
            product,
            renderDefinition,
            destinationsValue,
            destinations,
            submitFailed,
            groupType,
            change,
            channel,
            camcMembership,
            maydayBreakdown,
            addressSelected
        } = this.props;

        const {activitiesValid} = this.state;
        const hasAdditionalOption = size(product.metadata[`group_type_trip_${tripType}`]) > 4;
        const maxTripDurationList = map(product.metadata.annual_trip_durations, (name, key) => ({
            label: name,
            value: key,
        }));

        const maxTripDefinition = product.metadata.definitions.max_trip_duration;
        const showMaxTripSelect = size(maxTripDurationList) > 1;
        let advancedTime = 90;
        const timeType = 'day';
        let annualTime: number = 31;
        advancedTime = 31;
        if (!isAnnual(tripType)) {
            if (channel.key === 'tpl-b2c' || channel.key === 'csis-b2c') {
                advancedTime = 365;
            } else if (channel.key === 'camc-b2c') {
                advancedTime = 180;
            } else {
                advancedTime = 90;
            }
        }
        if(isAnnual(tripType)) {
            if (channel.key === 'csis-b2c') {
                annualTime = 30;
            }
        }
        let startDateMax = isAnnual(tripType) ? moment().add(annualTime, timeType) : moment().add(advancedTime, timeType);
        const camcAllowedDestinations = [
            'Andorra',
            'Albania',
            'Austria',
            'Azores',
            'Belarus',
            'Balearics',
            'Belgium',
            'Bosnia & Herzegovina',
            'Bulgaria',
            'Canary Islands',
            'Channel Islands',
            'Corsica',
            'Croatia',
            'Cyprus',
            'Czech Republic',
            'Denmark',
            'Estonia',
            'Faroe Islands',
            'Finland',
            'France',
            'Germany',
            'Georgia',
            'Gibraltar',
            'Greece',
            'Hungary',
            'Iceland',
            'Isle Of Man',
            'Italy',
            'Kosovo',
            'Latvia',
            'Liechtenstein',
            'Lithuania',
            'Luxembourg',
            'Macedonia',
            'Madeira',
            'Malta',
            'Moldova',
            'Monaco',
            'Montenegro',
            'Morocco',
            'Netherlands',
            'Norway',
            'Poland',
            'Portugal',
            'Republic of Ireland',
            'Romania',
            'Russia',
            'San Marino',
            'Serbia',
            'Sicily',
            'Slovakia',
            'Slovenia',
            'Spain',
            'Sweden',
            'Switzerland',
            'Tunisia',
            'Turkey',
            'United Kingdom',
            'Ukraine'
        ];
        const camcAllowedSet = new Set(camcAllowedDestinations);
        const camcDestinations = [];
        (Array.isArray(destinations) ? destinations : []).forEach(dest => {
            if (camcAllowedSet.has(dest.name)) {
                camcDestinations.push(dest);
            }
        });
        const {sources} = this.state;
        const maxDateSingle = () => {
            return moment(startDate, 'DD/MM/YYYY').clone().startOf('day').add(tripDurations[product.productCode], 'day').endOf('day');
        };

        const tripDurations = {
            CSIS: 89,
            CAMC: 89,
            TPL: 114,
        };

        const leadTime = {
            CSIS: 365,
            CAMC: 180,
            TPL: 365,
        };

        const showVoucherCode = () => {
            if(['csis-b2c', 'tpl-b2c'].includes(channel.key)) {
                return true;
            }
            return false;
        }

        const showWhereDidYouHearAboutUs = () => {
            if(['csis-b2c'].includes(channel.key)) {
                return true;
            }
            return false;
        }

        advancedTime = 31;

        if (!isAnnual(tripType)) {
            advancedTime = leadTime[product.productCode];
        }

        let singleLimitValue = advancedTime;

        const calendarStartDate = moment();

        const productDetails = get(product.metadata, 'content.product_details', '');

        const filteredTravellers = () => {
            const productMetadata = product.metadata[`group_type_trip_${tripType}`];
            if (!productMetadata) {
                return null;
            }

            const order = ['individual', 'couple', 'family', 'single_parent_family', 'independent_child'];

            return Object.entries(productMetadata)
                .sort(([keyA], [keyB]) => order.indexOf(keyA) - order.indexOf(keyB))
                .reduce((acc, [key, value]) => {
                    acc[key] = value;
                    return acc;
                }, {} as Record<string, any>);
        };

        const desiredOrder = [
            'uk',
            'europe',
            'europe_2',
            'worldwide_excluding',
            'worldwide'
        ];

        const regions = desiredOrder
            .map(key => {
                const name = product.metadata.regions[key];
                if (!name) {
                    return null;
                } // skip if not present
                if (name === 'Europe 1') {
                    return null;
                }

                // Rename "Europe 2" -> "Europe"
                const label = name === 'Europe 2' ? 'Europe' : name;

                return {label, value: key};
            })
            .filter(Boolean);

        return (
            <Form horizontal={true} onSubmit={handleSubmit} autoComplete="off">
                <div className="steps-container">
                    <div className="section-title">
                        <h1>Your Cover Details</h1>
                    </div>
                    <div className="section">
                        <ReactMarkdown source={productDetails}/>
                        <Field
                            name="confirmCover"
                            type="checkbox"
                            component={FieldFormControl}
                            validate={[mustConfirm('If you are unable to meet the above criteria, please call us to discuss an alternative product.')]}
                        >
                            I can confirm the above is correct
                            <div/>
                        </Field>
                    </div>
                    <div className="section">
                        <Row style={{marginBottom: '10px'}}>
                            <div style={{marginBottom: '20px'}}>
                                It’s important that you give us complete and accurate information. If you don’t this
                                could affect
                                whether we can offer
                                cover and could result in a claim not being paid.
                            </div>
                            {channel.key === 'camc-b2c' && (
                                <div className="info-card-primary">
                                    If you are unable to meet the above criteria, please contact our UK based travel
                                    team to discuss an alternative product on 02392 419 888 our lines are open
                                    Monday to Friday 9am to 5pm.
                                </div>
                            )}
                        </Row>
                    </div>
                    <MembershipDetails
                        sources={sources}
                        productKey={product.productCode}
                        change={change}
                        camcMembership={camcMembership}
                        maydayBreakdown={maydayBreakdown}
                    />
                    <div className="section">
                        <FormGroup controlId="trip-type">
                            <Row>
                                <Col sm={3}>
                                    <ControlLabel>
                                        Policy Type:
                                        {renderDefinition('trip_type')}
                                    </ControlLabel>
                                </Col>
                                <Col sm={9}>
                                    <Row className="trip-type-container">
                                        {map(product.metadata.trip_type, (name, key) => {
                                            return (
                                                <Col sm={6} key={key} className="trip-type-btn-container"
                                                     style={{marginBottom: '5px'}}>
                                                    <Field
                                                        name="tripType"
                                                        type="radio"
                                                        value={key}
                                                        component={FieldFormControl}
                                                    >
                                                        <div className={'trip-type-btn'}>
                                                            {name}
                                                            <FaCheck/>
                                                        </div>
                                                    </Field>
                                                </Col>
                                            );
                                        })}
                                    </Row>
                                </Col>
                            </Row>
                        </FormGroup>
                    </div>

                    {tripType === 'annual' && (
                        <div className="section">
                            {channel.key === 'camc-b2c' || channel.key === 'tpl-b2c' && (
                                <FormGroup controlId="start-date">
                                    <div className="internal-title">
                                        <h4>Where are you travelling to?</h4>
                                        {tripType === 'annual' && (
                                            renderDefinition('region')
                                        )}
                                    </div>
                                    <br/>
                                </FormGroup>
                            )}
                            {channel.key === 'csis-b2c' ? (
                                <FormGroup controlId="region">
                                    <Row>
                                        <Col sm={5}>
                                            <ControlLabel>
                                                Where are you travelling to?:
                                                {renderDefinition('region')}
                                            </ControlLabel>
                                        </Col>
                                        <Col sm={7}>
                                            <Field
                                                name="region"
                                                placeholder="Please select the region from the list"
                                                options={regions}
                                                component={SelectControl}
                                                clearable={false}
                                                validate={[isRequired]}
                                                onChange={this.handleRegion}
                                            />
                                        </Col>
                                    </Row>
                                </FormGroup>
                            ) : (
                                <FormGroup controlId="region">
                                    <Row>
                                        <Col sm={12}>
                                            <ControlLabel style={{height: '20px'}}>
                                                <div className="region-label">
                                                    <span>Please select the region from the list below</span>
                                                </div>
                                            </ControlLabel>
                                        </Col>
                                        <Col sm={12}>
                                            <Field
                                                name="region"
                                                placeholder="Select Region"
                                                options={regions}
                                                component={SelectControl}
                                                clearable={false}
                                                validate={[isRequired]}
                                                onChange={this.handleRegion}
                                            />
                                        </Col>
                                    </Row>
                                </FormGroup>
                            )}
                            {showMaxTripSelect && showDestinationDuration(tripType) && (
                                <FormGroup controlId="maxTripDuration">
                                    <MaxTripDuration
                                        i18n={i18n}
                                        options={maxTripDurationList}
                                        definition={maxTripDefinition}
                                        renderDefinition={renderDefinition}
                                    />
                                </FormGroup>
                            )}
                        </div>
                    )}

                    {tripType === 'single' && (
                        <div>
                            {channel.key === 'csis-b2c' ? (
                                <div className="section">
                                    <FormGroup controlId="destinations">
                                        <Row>
                                            <Col sm={3}>
                                                <ControlLabel>
                                                    Destination(s):
                                                    {renderDefinition('destinations')}
                                                </ControlLabel>
                                            </Col>
                                            <Col sm={9}>
                                                <FieldArray
                                                    name="destinations"
                                                    component={Destination as any}
                                                    i18n={i18n}
                                                    destinations={destinations}
                                                    channel={channel}
                                                    destinationsValue={destinationsValue}
                                                    renderDefinition={renderDefinition}
                                                />
                                            </Col>
                                        </Row>
                                    </FormGroup>
                                </div>
                            ) : (
                                <div className="section">
                                    {channel.key === 'camc-b2c' && (
                                        <FormGroup controlId="start-date">
                                            <div className="internal-title"><h4>Where are you travelling to?</h4></div>
                                            <br/>
                                        </FormGroup>
                                    )}
                                    {channel.key === 'tpl-b2c' && (
                                        <FormGroup controlId="start-date">
                                            <div className="internal-title">
                                                <h4>Where are you travelling to?</h4>
                                                {renderDefinition('region')}
                                            </div>
                                            <br/>
                                        </FormGroup>
                                    )}
                                    <FormGroup controlId="destinations">
                                        <Row>
                                            <Col sm={12}>
                                                <ControlLabel
                                                    style={{height: channel.key === 'camc-b2c' ? '120px' : 'auto'}}>

                                                    {channel.key === 'camc-b2c' ? (
                                                        <div className="region-label" style={{width: '100%'}}>
                                      <span>
                                        Let us know which countries you are planning to travel through/to.
                                        For multiple destinations, start typing the country name and select the option
                                        from the dropdown. To add more, select ‘add a country’
                                      </span>
                                                        </div>
                                                    ) : (
                                                        <div className="region-label">
                                                            <span>Please enter all countries you are travelling to.</span>
                                                        </div>
                                                    )}
                                                </ControlLabel>
                                            </Col>
                                            <Col sm={12}>
                                                <FieldArray
                                                    name="destinations"
                                                    component={Destination as any}
                                                    i18n={i18n}
                                                    destinations={channel.key === 'camc-b2c' ? camcDestinations : destinations}
                                                    channel={channel}
                                                    destinationsValue={destinationsValue}
                                                    renderDefinition={renderDefinition}
                                                />
                                            </Col>
                                        </Row>
                                    </FormGroup>
                                </div>
                            )}
                            {showMaxTripSelect && showDestinationDuration(tripType) && (
                                <FormGroup controlId="maxTripDuration">
                                    <MaxTripDuration
                                        i18n={i18n}
                                        options={maxTripDurationList}
                                        definition={maxTripDefinition}
                                        renderDefinition={renderDefinition}
                                    />
                                </FormGroup>
                            )}
                        </div>
                    )}

                    <div className="section">
                        <Row>
                            <FCDOText channel={channel}/>
                        </Row>
                    </div>

                    {tripType === 'single' && (
                        <div className="section">
                            <FormGroup controlId="start-date">
                                <div className="internal-title"><h4>When does your trip start and
                                        end?</h4> {renderDefinition('travel_dates_single_start_date')}</div>
                                <br/>
                            </FormGroup>
                            <FormGroup controlId="start-date"
                                       style={{display: 'flex', justifyContent: 'flex-start', flexDirection: 'row'}}>
                                <div className="start-date">
                                    <div className="start-date-inner">
                                        <div style={{width: '30%'}}>
                                            {channel.key === 'camc-b2c' ? 'Start:' : '*Start date:'}
                                        </div>
                                        <div style={{width: '70%'}}>
                                            <div className="alternative-date-picker">
                                                <div className="field">
                                                    <Field
                                                        name="startDate"
                                                        type="masked-date"
                                                        placeholder="dd/mm/yyyy"
                                                        component={FieldFormControl}
                                                        validate={[isAnnual(tripType) ? annualLimit(advancedTime) : singleLimit(singleLimitValue), isAfter(calendarStartDate), isBefore(startDateMax)]}
                                                    />
                                                </div>
                                                <div className="icon">
                                                    <Field
                                                        name="startDate"
                                                        minDate={calendarStartDate}
                                                        maxDate={startDateMax}
                                                        component={AlternativeDatePicker}
                                                        validate={[isAnnual(tripType) ? annualLimit(advancedTime) : singleLimit(singleLimitValue), isAfter(calendarStartDate), isBefore(startDateMax)]}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </FormGroup>
                            <FormGroup controlId="end-date"
                                       style={{display: 'flex', justifyContent: 'flex-start', flexDirection: 'row'}}>
                                <div style={{
                                    display: 'flex',
                                    justifyContent: 'flex-start',
                                    flexDirection: 'column',
                                    width: '70%'
                                }}>
                                    <div style={{
                                        display: 'flex',
                                        justifyContent: 'flex-start',
                                        flexDirection: 'row',
                                        width: '80%',
                                        marginBottom: '10px'
                                    }}>
                                        <div style={{width: '30%'}}>
                                            {channel.key === 'camc-b2c' ? 'End:' : 'Return date:'}
                                        </div>
                                        <div style={{width: '70%'}}>
                                            <div className="alternative-date-picker">
                                                <div className="field">
                                                    <Field
                                                        name="endDate"
                                                        type="masked-date"
                                                        placeholder="dd/mm/yyyy"
                                                        component={FieldFormControl}
                                                    />
                                                </div>
                                                <div className="icon">
                                                    <Field
                                                        name="endDate"
                                                        minDate={startDate ? moment(startDate, 'DD/MM/YYYY') : moment()}
                                                        maxDate={startDate ? maxDateSingle() : moment()}
                                                        component={AlternativeDatePicker}
                                                        validate={[
                                                            isRequired,
                                                            isFutureDate,
                                                            isValidDate,
                                                            // minTripDuration(startDate),
                                                            singleMaxTripDuration(startDate, tripDurations[product.productCode] || 365),
                                                        ]
                                                        }
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </FormGroup>
                        </div>
                    )}

                    {tripType === 'annual' && (
                        <div className="section">
                            <FormGroup controlId="start-date">
                                <div className="internal-title"><h4>When should the policy start?</h4></div>
                                <br/>
                            </FormGroup>
                            <FormGroup controlId="start-date"
                                       style={{display: 'flex', justifyContent: 'flex-start', flexDirection: 'row'}}>
                                <div className="start-date">
                                    <div className="start-date-inner">
                                        {channel.key !== 'camc-b2c' && (
                                            <div style={{width: '30%'}}>
                                                *Start date:
                                                {renderDefinition('travel_dates_annual')}
                                            </div>
                                        )}
                                        <div style={{width: '70%'}}>
                                            <div className="alternative-date-picker">
                                                <div className="field">
                                                    <Field
                                                        onValueChange={this.handleEndDate}
                                                        name="startDate"
                                                        type="masked-date"
                                                        placeholder="dd/mm/yyyy"
                                                        component={FieldFormControl}
                                                        validate={[
                                                            annualLimit(advancedTime),
                                                            isAfter(calendarStartDate),
                                                            isBefore(startDateMax),
                                                            singleLimit(singleLimitValue),
                                                        ]}
                                                    />
                                                </div>
                                                <div className="icon">
                                                    <Field
                                                        name="startDate"
                                                        minDate={calendarStartDate}
                                                        maxDate={startDateMax}
                                                        component={AlternativeDatePicker}
                                                        onValueChange={this.handleEndDate}
                                                        validate={[
                                                            annualLimit(advancedTime),
                                                            isAfter(calendarStartDate),
                                                            isBefore(startDateMax),
                                                            singleLimit(singleLimitValue),
                                                        ]}
                                                    />
                                                </div>
                                            </div>
                                            {isAnnual(tripType) && (
                                                channel.key === 'camc-b2c' ? (
                                                    <p style={{marginTop: '40px'}}>For annual policies, there is no
                                                        cover in place until
                                                        the policy starts. If you already have trips booked and need
                                                        cover for cancellation,
                                                        select the start date as today</p>
                                                ) : (
                                                    <p style={{marginTop: '40px'}}>Note - there is no cover in place
                                                        until the policy
                                                        starts</p>
                                                )
                                            )}
                                        </div>
                                    </div>
                                </div>
                            </FormGroup>
                        </div>
                    )}

                    <div className="section">
                        {channel.key === 'camc-b2c' && (
                            <FormGroup controlId="start-date">
                                <div className="internal-title"><h4>Who is going on the
                                    trip?</h4> {renderDefinition('group_type')}
                                </div>
                                <br/>
                            </FormGroup>
                        )}
                        <FormGroup controlId="group-type">
                            <Row>
                                {channel.key !== 'camc-b2c' && (
                                    <Col sm={3}>
                                        <ControlLabel>
                                            <div className="non-break-label">
                                                Travellers Details:{renderDefinition('group_type')}
                                            </div>
                                        </ControlLabel>
                                    </Col>
                                )}
                                <Col sm={hasAdditionalOption ? 12 : 9}>
                                    <Row className="group-type-radio">
                                        {map(filteredTravellers(), (name, key) => {
                                            return (
                                                <Col xs={6} sm={6} md={hasAdditionalOption ? 2 : 3} key={key}>
                                                    <Field
                                                        name="groupType"
                                                        type="radio"
                                                        value={key}
                                                        component={FieldFormControl}
                                                        validate={[isRequired]}
                                                        onChange={this.onSelectGroupType}
                                                    >
                                                        <div>
                                                            <GroupType channel={channel} name={String(key)}/>
                                                            <GroupTypeSelected channel={channel} name={String(key)}/>
                                                        </div>
                                                        {name}
                                                    </Field>
                                                </Col>
                                            );
                                        })}
                                    </Row>
                                </Col>
                            </Row>
                        </FormGroup>
                    </div>

                    <FieldArray
                        name="travellers"
                        i18n={i18n}
                        product={product}
                        component={Travellers}
                        addressSelected={addressSelected}
                        groupType={groupType}
                        renderDefinition={renderDefinition}
                        change={change}
                        backToIndividual={this.state.backToIndividual}
                    />
                        <div>
                            {showVoucherCode() && (
                                <VoucherCode
                                    renderDefinition={renderDefinition}
                                    {...this.props}
                                />
                            )}

                            {showWhereDidYouHearAboutUs() && (
                                <div className="section">
                                    <Row style={{marginBottom: '10px', marginTop: '-5px'}}>
                                        <Field
                                            name="whereDidYouHearAboutUs"
                                            type="text"
                                            placeholder={'How did you hear about us?'}
                                            component={FieldFormControl}
                                        />
                                    </Row>
                                </div>
                            )}
                        </div>
                    <div className="section">
                        {channel.key === 'camc-b2c' ? (
                            <div>
                                <FormGroup controlId="start-date">
                                    <div className="internal-title"><h4>Your communication preferences</h4></div>
                                    <br/>
                                </FormGroup>
                                <Row>
                                    {camcMembership === 'true' ? (
                                        <p>
                                            We love to keep our members informed about our products,
                                            offers, benefits, and services that will help you get the most
                                            out of the great outdoors.


                                            If you are a member your communications preferences have
                                            already been captured. You can change this information at
                                            any time through the My Profile link on our
                                            <a target="_blank" href="https://www.caravanclub.co.uk/">website</a>.
                                        </p>
                                    ) : (
                                        <div>
                                            <p>
                                                As you are not a member we would love to tell you more
                                                about the exciting benefits of being a Caravan and
                                                Motorhome Club member.
                                                <br/><br/>
                                                Please select the box below for us to stay in touch with you
                                                through email. Remember you can unsubscribe at any
                                                time.
                                            </p>
                                            <MarketingOptions/>
                                            <br/><br/>
                                            <p>
                                                If you would like to know how we process personal data,
                                                please visit our <a target="_blank" href={channel.urls.privacyCookies}>Privacy
                                                Policy</a>.
                                            </p>
                                        </div>
                                    )}
                                </Row>
                            </div>
                        ) : (
                            <Row>
                                <MarketingOptions/>
                            </Row>
                        )}
                    </div>
                    {channel.key === 'camc-b2c' ? (
                        <div className="section">
                            <FormGroup controlId="start-date">
                                <div className="internal-title"><h4>Your personal data</h4></div>
                                <br/>
                            </FormGroup>
                            <Row>
                                <div className="getting-back-quotes-box">
                                    <p>
                                        PJ Hayman & Company Ltd will use the information provided
                                        to supply you with a quote or policy in relation to your travel
                                        insurance.
                                    </p>
                                    <p>
                                        They need your consent to use the sensitive details about
                                        you in connection with your travel insurance. Where you
                                        have provided them with details about other people, P J
                                        Hayman and other insurance market participants also need
                                        their consent to use the sensitive details in connection with
                                        the insurance cover. We need you to make sure you have
                                        obtained the necessary consent before you proceed.
                                    </p>
                                    <p>
                                        For more information about the P J Hayman service to you
                                        and how they will use your information, please read their <a target="_blank"
                                                                                                     href={channel.urls.contactUs}>Terms
                                        of Business</a> and <a target="_blank" href={channel.urls.privacyCookies}>Privacy
                                        Policy</a>.
                                    </p>

                                    <br/>
                                    <Field
                                        style={{marginBottom: '20px'}}
                                        name="dataConsentChoice"
                                        type="checkbox"
                                        component={FieldFormControl}
                                        validate={[
                                            isRequired,
                                            isNotFalse,
                                        ]}
                                    >
                                        Please tick to confirm you have read and understand the
                                        above statement and are happy to proceed on this basis.
                                        <div/>
                                    </Field>
                                    <p>
                                        If you have any specific needs or require any additional
                                        support, you can let us know by contacting the travel team
                                        on the number shown and we will be happy to help.
                                    </p>

                                </div>
                            </Row>
                        </div>
                    ) : (
                        <div className="section">
                            <Row>
                                <div className="getting-back-quotes-box">
                                    <p>
                                        We need your consent to use the sensitive details about you in connection with
                                        your insurance,
                                        Where you have provided us details about other people, we and other insurance
                                        market participants
                                        also need their consent to use the sensitive details about them in connection
                                        with your insurance
                                        cover. We need you to make sure you have obtained their consent before you
                                        proceed.
                                    </p>
                                    <Field
                                        name="dataConsentChoice"
                                        type="checkbox"
                                        component={FieldFormControl}
                                        validate={[
                                            isRequired,
                                            isNotFalse,
                                        ]}
                                    >
                                        Please tick to confirm you have read and understand the above statement and are
                                        happy to proceed on
                                        this basis.
                                        <div/>
                                    </Field>
                                </div>
                            </Row>
                        </div>
                    )}

                    {channel.key !== 'camc-b2c' && (
                        <div className="aboutUs">
                            {this.renderAboutUs()}
                        </div>
                    )}
                    <hr/>
                    <div className="btn-bar">
                        <Button
                            id="continue"
                            bsStyle="primary"
                            className="pull-right btn-remove-border"
                            onClick={this.checkForErrorBeforeSubmit}
                            disabled={submitting || (submitFailed && !valid) || !activitiesValid}
                        >
                            <span className="btn-text">Continue to next step</span> <FaChevronRight/>
                        </Button>
                    </div>
                </div>
                {
                    this.renderBlockerModal()
                }
            </Form>
        );
    }
}

let selector;
let previousValues;

export default flow([
    reduxForm({
        form: 'quote',
        destroyOnUnmount: false,
        forceUnregisterOnUnmount: true,
        onSubmitFail: () => {
            setTimeout(() => scrollToFirstError({offset: 120}), 0);
        },
        onChange: (
            values: IPolicyApplication,
            dispatch,
            props: ITripDetailsJourneyBFormProps,
        ) => {
            if (!previousValues) {
                previousValues = values;
                return;
            }

            let recalculateScore = false;

            if (difference(values.destinations, previousValues.destinations).length > 0) {
                recalculateScore = true;
            }

            if (values.region !== previousValues.region) {
                recalculateScore = true;
            }

            if (recalculateScore) {
                props.actions.quote.recalculateScreening();
            }

            previousValues = values;
        },
    }),
    (component) => {
        selector = formValueSelector('quote');

        return component;
    },
    connect(
        (state: IStore) => {
            const tripType = selector(state, 'tripType');
            const groupType = selector(state, 'groupType');
            const startDate = selector(state, 'startDate');
            const endDate = selector(state, 'endDate');
            const destinationsValue = selector(state, 'destinations');
            const occupationValue = selector(state, 'occupations');
            const industryValue = selector(state, 'industries');
            const region = selector(state, 'region');
            const maxTripDuration = selector(state, 'maxTripDuration');
            const residency = selector(state, 'residency');
            const quotationTypes = selector(state, 'quotationTypes');
            const schemeId = selector(state, 'schemeId');
            const cruiseCover = selector(state, 'cruiseCover');
            const travellers = selector(state, 'travellers');
            const salesChannel = selector(state, 'salesChannel');
            const activities = selector(state, 'activities');
            const ageVehicle = selector(state, 'ageVehicle');
            const camcMembership = selector(state, 'camcMembership');
            const maydayBreakdown = selector(state, 'maydayBreakdown');
            const addressSelected = selector(state, 'addressSelected');

            return {
                cruiseCover,
                tripType,
                quotationTypes,
                residency,
                region,
                maxTripDuration,
                groupType,
                startDate,
                schemeId,
                endDate,
                destinationsValue,
                occupationValue,
                industryValue,
                travellers,
                auth: state.auth,
                channel: state.branding.channel,
                branding: state.branding,
                salesChannel,
                activities,
                ageVehicle,
                campaignCode: state.quote.campaignCode,
                camcMembership,
                maydayBreakdown,
                addressSelected
            };
        },
        (dispatch) => ({
            actions: {
                submit: bindActionCreators(submit, dispatch),
                quote: bindActionCreators({...quoteActions}, dispatch),
                branding: bindActionCreators({...brandingActions}, dispatch),
            },
        }),
    ),
])(TripDetailsJourneyBForm);




// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/scenes/Quote/scenes/TripDetailsJourneyB/index.tsx